import axios, { AxiosError } from 'axios';

import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';

import { logServerError } from '../../common';
import { Http, injectToken } from '../../common/api';
import { BasketExceptionResponse } from '../models/basket-exception-response';

export class BasketHttp extends Http {
  protected initializeResponseInterceptor() {
    this.http.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (axios.isAxiosError<BasketExceptionResponse>(error)) {
          const basketException = error.response?.data;
          const message = basketException?.fault?.arguments?.statusMessage;
          if (message) alert(message);
          if (basketException?.fault) return Promise.reject(basketException.fault);
        }

        logServerError(error);
        return Promise.reject(error);
      }
    );
  }

  protected initializeRequestInterceptor() {
    this.http.interceptors.request.use(
      async (config) => {
        const authToken = await getWebStoreApiClient().onTokenAcquired;

        return injectToken(authToken)(config);
      },
      (error) => Promise.reject(error)
    );
  }
}
